module.exports = __webpack_public_path__ + "static/img/activity03.01be77f3.png";